import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const InboxIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M4.12 19.84V4.08H19.88V19.84H4.12ZM5.96 13.94H9.96C9.96 15.06 10.88 15.98 12 15.98C13.12 15.98 14.04 15.06 14.04 13.94H18.04V5.92H5.96V13.94Z" />
    </SvgIcon>
  );
});
